const theme = {
  colors: {
    heading: "#283046",
    text: "#4F5D75",
    white: "#FFFFFF",
    black: "#1C1C1C",
    helper: "#FF6B6B",
    hover_bg: "#FFA5A5",
    active_bg: "#FFDADA",
    bg: "#F0F4F7",
    footer_bg: "#F0F4F7",
    btn: "#55CBCD",
    border: "#D3D8E2",
    hr: "#E8EDF2",
    number: "#1C1C1C",
    shadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    shadowSupport: "0px 3px 6px rgba(0, 0, 0, 0.1)",
    mainLogo: "#F25F5C",
    warning: "#e74c3c",
  },
  typography: {
    fontSize: {
      small: "0.8rem",
      medium: "1rem",
      large: "1.2rem",
    },
    fontFamily: "'Nunito', sans-serif",
  },
  media: {
    mobile: "768px",
    tab: "998px",
    desktopLarge: "1534px",
  },
};

export default theme;
